var $class="se2--form-email-sign-up-embedded",$name="FormEmailSignUpEmbedded",$path="app/components/FormEmailSignUpEmbedded/index.js",$this={$class,$name,$path,};import onFormSubmitMessage from 'app/components/utilities/onFormSubmitMessage';
import sha256 from 'app/utilities/sha256';

import analytics from 'app/modules/analytics';
import shell from 'app/modules/shell';
import 'app/partials/captcha';
import 'app/partials/checkbox';
import 'app/partials/formComponentWrapper';
import 'app/partials/input';
import 'app/partials/notification';
import 'app/partials/radioBtn';
import 'app/partials/select';
import 'app/partials/submit';
import 'app/partials/textarea';
import 'app/partials/inputCountrySelector';
import { css } from 'configs';

export default shell.registerPartial($this, ({ addEventListener, mount, configs, subscribeToMessage }) => {
  const formGroupClassName = 'form-group';
  let form = null;

  const trackAnalytics = async () => {
    const formId = form.id;
    const formObj = Object.fromEntries(new FormData(form));
    const formEmail = formObj.emailOrPhone;

    const lowercaseEmail = formEmail ? formEmail.toLowerCase() : ' ';

    let userHashedEmail = '';
    await sha256(lowercaseEmail).then((hex) => { userHashedEmail = hex; });

    analytics.trackNewsletterSubscription({ siteLocationKey: 'Page' });
    analytics.trackContactSubmit({
      formId,
      userHashedEmail,
      formObj,
    });
  };

  mount((element) => {
    const emailField = element.querySelector('.input-email');
    const phoneField = element.querySelector('.input-tel');
    const madatoryFieldErr = element.querySelector('.madatoryFieldErr');

    const onChange = () => {
      if (phoneField?.value || emailField?.value) {
        emailField?.closest(`.${formGroupClassName}`).classList.remove('madatoryField');
        phoneField?.closest(`.${formGroupClassName}`).classList.remove('madatoryField');
        madatoryFieldErr?.classList.remove(css.classNames.show);
      }

      if (emailField?.value && !phoneField?.value) {
        phoneField?.closest(`.${formGroupClassName}`).classList.remove('incorrect');
      }

      if (emailField?.value && phoneField?.value.length <= 4) {
        if (phoneField?.value.startsWith('+')) {
          phoneField?.closest(`.${formGroupClassName}`).classList.remove('incorrect');
        }
      }
    };

    addEventListener(element, 'change', onChange);

    form = element;

    subscribeToMessage(
      configs.messages.formSubmit,
      ({ status, formId }) => onFormSubmitMessage(form, formId, status, trackAnalytics),
    );
    const snackbarContainer = document.querySelector('.snackbar-container');
    if (snackbarContainer !== undefined) {
      snackbarContainer?.classList.add('snackbar-margin');
    }
  });
});
